import message from 'antd/es/message';
import {client} from '../../apollo/apolloClient';
import {
  CHANGE_CASH_COUNT,
  CHANGE_SERUM_COUNT,
  CHANGE_USER_LOGIN_STATUS,
  CHANGE_USER_PRIME_DATA,
  GET_USER_PRIME_STATUS,
  SHOW_AUTH_MODAL,
  STORE_USER_DATA,
  STORE_WALLET_DATA,
} from './types';
import {
  GET_CASH_DATA,
  GET_USER_DATA_AND_WALLET,
  GET_WALLET_DATA,
} from '../../apollo/schema';
import {
  getUserPrimeData,
  initiateOrDestroyChatUsingPath,
} from '../../helpers/util';

export function changeLoginStatus(status) {
  return {
    type: CHANGE_USER_LOGIN_STATUS,
    payload: status,
  };
}

export function setUserPrimeStatus(status) {
  return {
    type: GET_USER_PRIME_STATUS,
    payload: status,
  };
}

export function setUserPrimeData(authToken) {
  const {isPrime, videoPass, testPass} = getUserPrimeData(authToken);
  return {
    type: CHANGE_USER_PRIME_DATA,
    payload: {isPrime, videoPass, testPass},
  };
}

export function changeAuthModal(status) {
  return {
    type: SHOW_AUTH_MODAL,
    payload: status,
  };
}

export function storeUserData() {
  return async dispatch => {
    client.query({
      query: GET_USER_DATA_AND_WALLET,
    }).then(res => {
      if (res.errors !== undefined && res.errors.length > 0) {
        message.error('Something went wrong. Please try again');
      } else {
        const {me, getWallet} = res.data;
        initiateOrDestroyChatUsingPath(me);
        dispatch({
          type: STORE_USER_DATA,
          payload: {
            userData: me,
            walletData: getWallet,
          },
        });
      }
    });
  };
}

export function updateSerum(serum, count) {
  return async dispatch => {
    dispatch({
      type: CHANGE_SERUM_COUNT,
      payload: serum + count,
    });
  };
}

export function updateCash(action, count) {
  return async dispatch => {
    client.query({
      query: GET_CASH_DATA,
    }).then(res => {
      if (res.errors !== undefined && res.errors.length > 0) {
        message.error('Something went wrong. Please try again');
        dispatch({
          type: '',
          payload: '',
        });
      } else {
        const {cash} = res.data.getWallet;
        if (action === '+') {
          dispatch({
            type: CHANGE_CASH_COUNT,
            payload: cash + count,
          });
        } else {
          if (cash === 0 || cash === undefined || cash === null || cash <
              count) {
            message.error('You dont have enough cash');
            dispatch({
              type: '',
              payload: '',
            });
          } else {
            dispatch({
              type: CHANGE_CASH_COUNT,
              payload: cash - count,
            });
          }
        }
      }
    });
  };
}

export function getWalletData() {
  return async dispatch => {
    client.query({
      query: GET_WALLET_DATA,
    }).then(res => {
      if (res.errors !== undefined && res.errors.length > 0) {
        dispatch({
          type: '',
          payload: '',
        });
      } else {
        const {getWallet} = res.data;
        dispatch({
          type: STORE_WALLET_DATA,
          payload: getWallet,
        });
      }
    }).catch(() => {
      dispatch({
        type: '',
        payload: '',
      });
    });
  };
}

export function storeWalletData(data) {
  return async dispatch => {
    dispatch({
      type: STORE_WALLET_DATA,
      payload: data,
    });
  };
}
